import { GetStaticProps } from 'next';
import { CommunityPageId } from '../../../features/app/pages/domain/constants/PageId';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import {
	GenericLandingPage,
	IGenericLandingPageProps,
} from '../../../features/app/pages/ui/GenericLandingPage';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import {
	COMMUNITY_HOME_HEADER_DESKTOP,
	COMMUNITY_HOME_HEADER_MOBILE,
} from '../../../features/shared/api/contentful/constants';
import { getHeaderImages } from '../../../features/shared/layout/header/image/getHeaderImages';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IGenericLandingPageProps> =
	createGetStaticPropsWithPage(CommunityPageId.Home, {
		headerImages: () =>
			getHeaderImages(
				COMMUNITY_HOME_HEADER_DESKTOP,
				COMMUNITY_HOME_HEADER_MOBILE,
			),
	});

export default GenericLandingPage;
